module.exports = __webpack_public_path__ + "static/media/2.fae2f01d.png";